import { create } from 'zustand'
import { getMonthCloseNavStatus } from '@/services/monthCloseNavStatus'

interface MonthCloseNavState {
  preferredEquityCount: number
  bankReconCount: number
  incomeAllocationCount: number
  benefitsCount: number
  setPreferredEquityCount: (count: number) => void
  setBankReconCount: (count: number) => void
  setIncomeAllocationCount: (count: number) => void
  setBenefitsCount: (count: number) => void
  fetchNavStatus: () => Promise<void>
}

export const useMonthCloseNavStore = create<MonthCloseNavState>((set) => ({
  preferredEquityCount: 0,
  bankReconCount: 0,
  incomeAllocationCount: 0,
  benefitsCount: 0,
  setPreferredEquityCount: (preferredEquityCount) => set({ preferredEquityCount }),
  setBankReconCount: (bankReconCount) => set({ bankReconCount }),
  setIncomeAllocationCount: (incomeAllocationCount) => set({ incomeAllocationCount }),
  setBenefitsCount: (benefitsCount) => set({ benefitsCount }),
  fetchNavStatus: async () => {
    try {
      const status = await getMonthCloseNavStatus()
      set({
        preferredEquityCount: status.preferred_equity_incomplete_count,
        bankReconCount: status.bank_recon_incomplete_count,
        incomeAllocationCount: status.income_allocation_incomplete_count,
        benefitsCount: status.benefits_incomplete_count,
      })
    } catch (err) {
      console.error('Failed to fetch month-close nav status:', err)
    }
  },
}))
